import React from 'react';
import AlertBar from '../../../../alerts/AlertBar';

const PreOpDataAny = () => {
  return <AlertBar title='Warning' severity='warning' text='No field for selected procedure' />;
};

export default PreOpDataAny;
